import type { Address } from "./models/address";


export function formatPackLabel(input: string): string {
  return input
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function formatAddressForHTML(addr: Address): string {
  let customerAddress: string = "";
  if(addr.houseNo && addr.houseNo.length > 0){
    customerAddress += `${addr.houseNo} `;
  }

  if(addr.street && addr.street.length > 0){
    customerAddress += `${addr.street} `;
  }

  if(customerAddress.length > 0){
    customerAddress += "<br />";
  }

  if(addr.city && addr.city.length > 0){
    customerAddress += `${addr.city} `;
  }

  if(addr.postcode && addr.postcode.length > 0){
    customerAddress += `${addr.postcode}`;
  }

  customerAddress = customerAddress.trim();

  return customerAddress;
}


// Compress image to reduce memory usage
/*
async function compressImage(file: File, maxWidth = 1200, maxHeight = 1200, quality = 0.8): Promise<File> {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        let { width, height } = img;
        
        // Calculate new dimensions while maintaining aspect ratio
        if (width > maxWidth || height > maxHeight) {
          const aspectRatio = width / height;
          if (width > height) {
            width = maxWidth;
            height = width / aspectRatio;
          } else {
            height = maxHeight;
            width = height * aspectRatio;
          }
        }
        
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d')!;
        ctx.drawImage(img, 0, 0, width, height);
        
        canvas.toBlob((blob) => {
          const compressedFile = new File([blob!], file.name, {
            type: 'image/jpeg',
            lastModified: Date.now()
          });
          resolve(compressedFile);
        }, 'image/jpeg', quality);
      };
      img.src = e.target!.result as string;
    };
    reader.readAsDataURL(file);
  });
}
*/

